import "./separator.scss"

const Separator = ({children}) => {
    return <div className="separator">{children}</div>
}

export default Separator;